import { Grid, Typography } from '@mui/material'

import useStyles from './index.styles'

const Slide = ({ image, title, subtitle }: { image: string; title: string; subtitle: string }) => {
  const classes = useStyles

  return (
    <Grid container={true} sx={classes.slideOuterContainer}>
      <img src={image} alt="" width="100%" />

      <Grid container={true} size={12} sx={classes.slideInnerContainer}>
        <Typography variant="subtitle2">{title}</Typography>

        <Typography variant="h6" sx={classes.slideSubtitle}>
          {subtitle}
        </Typography>
      </Grid>
    </Grid>
  )
}

export default Slide
